<template>
	<div>
		<navigation msg="设备订单/设备管理" />
		<router-view />
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default {
		data() {
			return {
	
			}
		},
		components: {
			navigation
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/facility/macOrder/mac/home.vue